import React from 'react';
import { compose } from 'redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
import withEnterKeyManager from 'hocs/WithEnterKeyManager';
// Core components
import Card from 'components/core/Card';
import TextField from 'components/core/TextField';
// Custom
import { isValidPhoneNumber } from 'utils/Tools';
import { buildFormErrors, completeFormErrors, cpmCarparkContactConstraints } from 'utils/Forms';
import PhoneNumberInputField from 'components/inputFields/PhoneNumberInputField';
import FormDialogTemplate from 'components/templates/FormDialogTemplate';

class CarparkContactEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  componentDidUpdate(prevProps) {
    // Check if enter key has been pressed
    const { enterPressed } = this.props;
    const { enterPressed: prevEnterPressed } = prevProps;
    if (!prevEnterPressed && enterPressed) {
      this.handleValidate();
    }
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: { email, phone },
      onErrorsChange,
      onValidate,
    } = this.props;

    let errors = buildFormErrors({ email }, cpmCarparkContactConstraints);
    if (phone && !isValidPhoneNumber(phone)) {
      errors = completeFormErrors(errors, 'phone', ['isInvalid']);
    }
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate({ email, phone });
      return true;
    }
    return false;
  }

  render() {
    const {
      readOnly,
      fields: { email, phone },
      errors,
      onFieldsChange,
      onKeyPress,
    } = this.props;

    return (
      <FormDialogTemplate errors={errors}>
        <div className="row">
          <div className="col-12">
            <Card>
              <div className="row">
                <div className="col-12">
                  <TextField
                    label={<LocalizedMessage id="field.email" />}
                    value={email}
                    errorText={_get(errors, 'email')}
                    onChange={(value) => onFieldsChange({ email: value })}
                    onKeyPress={onKeyPress}
                    readOnly={readOnly}
                  />

                  <PhoneNumberInputField
                    label={<LocalizedMessage id="field.phoneNumber" />}
                    value={phone}
                    errorText={_get(errors, 'phone')}
                    onChange={(value) => onFieldsChange({ phone: value })}
                    readOnly={readOnly}
                  />
                </div>
              </div>
            </Card>
          </div>
        </div>
      </FormDialogTemplate>
    );
  }
}

CarparkContactEditForm.propTypes = {
  contact: PropTypes.shape({
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired, // eslint-disable-line react/no-unused-prop-types
  readOnly: PropTypes.bool,
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  enterPressed: PropTypes.bool.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func,
};

CarparkContactEditForm.defaultProps = {
  errors: null,
  onValidate: null,
  readOnly: false,
};

const mapFieldsToProps = {
  email: {
    resourceKey: 'email',
    defaultValue: '',
  },
  phone: {
    resourceKey: 'phone',
    defaultValue: '',
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps.contact,
});

module.exports = compose(
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false),
  withEnterKeyManager,
)(CarparkContactEditForm);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/main/CarparkContactEditForm.js